import { AxiosError, AxiosRequestConfig } from 'axios';
import axiosInstance from 'Config/axios/axios-config';
import type { FetchResponseI } from 'types';

export async function fetchData<T>(url: string, options: AxiosRequestConfig = {}): Promise<FetchResponseI<T>> {
  try {
    const response = await axiosInstance({
      url,
      ...options,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });

    if (options.responseType === 'blob') {
      return {
        data: response.data,
        error: null,
      };
    }

    // Para respuestas normales, mantenemos la estructura data.data
    return {
      data: response.data?.data,
      error: null,
    };
  } catch (error) {
    const response: FetchResponseI<null> = {
      data: null,
      error: 'Ocurrio un problema, intentalo nuevamente',
    };

    if (error instanceof AxiosError) {
      response.error = error.response?.data?.error;
    } else if (error instanceof Error) {
      response.error = error.message;
    }

    return response;
  }
}
